import React, { useRef } from 'react'
import SendIcon from '@material-ui/icons/Send'
import AttachFileRoundedIcon from '@material-ui/icons/AttachFileRounded'
import NoteModal from 'components/NoteModal'

const Question = ({ textArray, question, handleChange, gotoPurchase, sendLoading }) => {
    const textInput = useRef(null)
    const noteModal = useRef(null)

    const resizeInput = () => {
        const textarea = textInput.current

        if (textarea && textarea.scrollHeight < 300) {
            textarea.style.height = 0
            textarea.style.height = textarea.scrollHeight + 'px'
        }
    }

    const handleTextArea = e => {
        handleChange(e)
        resizeInput()
    }

    const openNoteModal = () => noteModal.current.openModal()

    return (
        <>
            <div className="background"></div>
            <div className="chatContainer">
                <div className="psudo">
                    <div className="MessageRow">
                        {textArray.map(txt =>
                            <div className="ChatMessage" key={txt}>
                                <span className="text">{txt}</span>
                            </div>
                        )}
                        <div className="ChatMessage">
                                <span className="text">تماس با پشتیبانی ازمسیرهای زیر امکان پذیر است: <br></br>
تلفن(پاسخگویی بین ساعات ۹ تا ۱۸): <br></br>
<a href= "tel:02171148100">02171148100</a> <br></br>
واتساپ(پاسخگویی بین ساعات ۹ تا ۱۸): <br></br>
<a href = "https://wa.me/989012175046">09012175046</a></span>
                            </div>
                    </div>
                </div>
            </div>
            <div className="chatFooter">
                <div className="text-message">
                    {sendLoading ?
                        <SendIcon style={{ marginLeft: 5, color: '#ccc' }} /> :
                        <SendIcon style={{ marginLeft: 5 }} onClick={gotoPurchase} />
                    }
                    <div className="chatInputWrapper">
                        <textarea
                            rows="1"
                            className="chatInput"
                            placeholder="شرح حال ..."
                            onChange={handleTextArea}
                            onFocus={resizeInput}
                            ref={textInput}
                            value={question}
                        />
                    </div>
                    <AttachFileRoundedIcon style={{ margin: '0 5px' }} onClick={openNoteModal} />
                </div>
            </div>
            <NoteModal ref={noteModal} message="پس از تایید درخواست توسط پزشک امکان ارسال عکس یا فایل را در گفتگو دارید." />
        </>
    )
}

export default Question